import { useMemo } from 'react';
import { useAnswerCodes } from './useAnswerCodes';

export interface SumpPumpLocation {
  sump_pump_type?: string;
  sump_pump_auxiliary_power?: string;
}

interface SumpPumpLogic {
  hasSumpPump: boolean;
  isOtherType: boolean;
  isOtherAuxiliaryPower: boolean;
}

export const useSumpPumpLogic = (location: SumpPumpLocation): SumpPumpLogic => {
  const { shouldShowConditionalField } = useAnswerCodes();

  return useMemo(() => {
    const sumpPumpType = location?.sump_pump_type || '';
    const auxiliaryPower = location?.sump_pump_auxiliary_power || '';

    const hasSumpPump = shouldShowConditionalField(
      'alarmed_sump_pump',
      sumpPumpType,
    );

    const isOtherType = shouldShowConditionalField(
      'other_sump_pump_type',
      sumpPumpType,
    );

    const isOtherAuxiliaryPower = shouldShowConditionalField(
      'other_sump_pump_auxiliary_power',
      auxiliaryPower,
    );

    return { hasSumpPump, isOtherType, isOtherAuxiliaryPower };
  }, [
    location?.sump_pump_type,
    location?.sump_pump_auxiliary_power,
    shouldShowConditionalField,
  ]);
};
